import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-scrim.css';
import { EGDSScrimType, EGDSScrimColorType } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { validatePropType } from '../../utils/validate-prop-types/index.esm.js';
import { EGDSContextProvider } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSScrim extends React.PureComponent {
  static displayName = 'EGDSScrim';
  static defaultProps = {
    type: EGDSScrimType.BOTTOM
  };
  render() {
    const {
      tag,
      type,
      children,
      className,
      color
    } = this.props;
    let Tag = '';
    const isBottomScrim = type === EGDSScrimType.BOTTOM;
    const isOverlayScrim = type === EGDSScrimType.OVERLAY;
    if (tag && tag !== '') {
      Tag = tag;
    } else {
      Tag = 'div';
    }
    const wrapperClassNames = getClassNameList('uitk-scrim', className, {
      [`${type}`]: validatePropType(type, EGDSScrimType)
    }, {
      [`${color}`]: validatePropType(color, EGDSScrimColorType)
    });
    const contextData = {
      bottomScrimContext: isBottomScrim,
      overlayScrimContext: isOverlayScrim
    };
    return jsx(Tag, {
      className: wrapperClassNames,
      children: jsx(EGDSContextProvider, {
        config: {
          context: 'uitk-scrim-context',
          data: contextData
        },
        children: children
      })
    });
  }
}
export { EGDSScrim };